<template>
  <div :class="containerClass()" ref="container">
    <div class="dashboard" v-if="this.$store.state.helpers.postToggle == '' && streamName=='home'">
      <div style="padding:11px;" class="story-header">
        <img class="post-profile-pic" style="cursor: pointer;" @click="goToProfile()"
          v-if="myProfilePic != '' && myProfilePic != undefined" :src="profilepath + myProfilePic">
        <img class="post-profile-pic" src="/assets/spyguy.png" v-if="myProfilePic == '' || myProfilePic == undefined">
        <div class="post-button" id="posting" @click="choosePostType">
          {{ $t('placeholder.newpost') }}
        </div>
      </div>
    </div>
    <ElectionFilter v-if="this.$store.state.auth.token != '' && streamName=='elections'" v-model:refreshFeed="electionRefresh" />
    <div v-if="(stories==null || stories.length==0) && !networkTimeout">
      <div class="dashboard" v-for="index in 3" :key="index" :style="dashMarginOverride()">
        <div class="story-header">
          <div class="story-header-pic">
            <ion-skeleton-text style="width:38px; height:38px; border-radius: 5px;"
              :animated="true"></ion-skeleton-text>
          </div>
          <div class="story-header-content">
            <div class="story-header-post">
              <span class="full-name-header">
                <ion-skeleton-text style="height:0.97em; margin: 5px 0px 5px 0px; width:50%;"
                  :animated="true"></ion-skeleton-text>
                <ion-skeleton-text style="height:1.0em; margin-bottom: 5px; width:50%;"
                  :animated="true"></ion-skeleton-text>
              </span>
            </div>
          </div>
        </div>
        <div class="story-name-block">
          <ion-skeleton-text style="height:24px; width:75%;" :animated="true"></ion-skeleton-text>
        </div>
        <ion-skeleton-text class="feature-img" style="height:340px;" :animated="true"></ion-skeleton-text>
      </div>
    </div>
    <div class="dashboard" :style="dashMarginOverride()" v-if="networkTimeout">
      <div style="height: 360px;">
        <ion-grid>
          <ion-row class="ion-margin-top ion-text-center">
            <ion-col>
              <h3>Oops, something went wrong</h3>
              <p v-html="'Check your internet connection'"></p>
              <ion-button @click="tryAgain">Try Again</ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
    <div class="dashboard" :style="dashMarginOverride()" v-if="stories!=null && stories.length!=0 && stories[0].noposts!=null">
      <WelcomeContainer v-if="streamName=='home'" />
      <GroupsContainer v-else-if="streamName=='groupfeed'" />
      <div v-else style="height: 360px;">
        <ion-grid>
          <ion-row class="ion-margin-top ion-text-center">
            <ion-col>
              <h3>No Posts</h3>
              <p v-html="showNoPostDetail()"></p>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
    <div v-else class="dashboard" :style="dashMarginOverride()" :ref="'story' + story.pik_id" v-for="(story, index) in stories"
     :key="'storykey-' + index + '-' + story.piklist_id">
      <PostContainer v-if="story.allimages.length == 1" :streamName="streamName" :streamIndex="index" :story="story"
        :userid="userid" :myProfileId="myProfileId" :scrollContainer="scrollContainerObject"  v-model:imageSelected="imageSelected" />
      <SliderContainer v-else :streamName="streamName" :streamIndex="index" :story="story" :userid="userid"
        :myProfileId="myProfileId" v-model:imageSelected="imageSelected" />
      <div v-if="pagingloading == index" style="display:block; width:100%; height: 480px;">
        <ion-spinner name="lines" style="width:100%; height: 64px; margin-top:208px;"></ion-spinner>
      </div>
    </div>
    <ion-infinite-scroll class="home-feed-col" @ionInfinite="loadMore($event)" id="infinite-scroll" threshold="30%"
      :disabled="(streamName == 'story')">
      <ion-infinite-scroll-content loading-spinner="bubbles" :loading-text="$t('loadmessage.loadingexplore')">
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
    <div v-if="streamName == 'story' && stories != null && stories.length > 0 && stories[0].allimages.length > 1"
      :style="dashMarginOverride()" class="dashboard">
      <p style="margin-left:20px"><strong>{{ $t('modalhead.morestory') }} - {{ stories[0].piklist_name }}</strong></p>
      <ion-segment :value="listType" @ionChange="changeListType($event)">
        <ion-segment-button value="list">
          <ion-label><ion-icon slot="start" style="font-size:18px;" :icon="list"></ion-icon></ion-label>
        </ion-segment-button>
        <ion-segment-button value="grid">
          <ion-label><ion-icon :icon="grid"></ion-icon></ion-label>
        </ion-segment-button>
      </ion-segment>
      <ShowMoreContainer v-if="listType == 'grid'" :story="stories[0]" v-model:imageSelected="imageSelected" />
      <ShowMoreListContainer v-if="listType == 'list'" :story="stories[0]" v-model:imageSelected="imageSelected" />
    </div>

  </div>
</template>

<script>
import { actionSheetController, IonInfiniteScroll, IonInfiniteScrollContent, modalController, IonLabel, IonSpinner, alertController, IonSegment, IonIcon, IonSegmentButton, IonSkeletonText, IonGrid, IonCol, IonRow, loadingController, IonButton } from '@ionic/vue';
import { pencil, grid, list } from 'ionicons/icons';
import { defineComponent, defineAsyncComponent } from 'vue'
import getEnv from '@/utils/env'
const WelcomeContainer = defineAsyncComponent(() =>
  import('@/components/WelcomeContainer.vue'))

const GroupsContainer = defineAsyncComponent(() =>
  import('@/components/groups/GroupsContainer.vue'))

const PostModal = defineAsyncComponent(() =>
  import('@/components/posts/CreatePost.vue'))

import SliderContainer from '@/components/SliderContainer.vue'
import PostContainer from '@/components/PostContainer.vue'
import ShowMoreContainer from '@/components/ShowMoreContainer.vue';
import ShowMoreListContainer from '@/components/ShowMoreListContainer.vue';
import ElectionFilter from '@/components/ElectionFilter.vue';

export default defineComponent({
  name: 'FeedContainer',
  emits: ['update:refreshFeed','update:networkTimeout'],
  props: {
    streamName: { String, default: 'home' },
    filter: { String, default: '' },
    userid: { Number, default: null },
    groupid: { Number, default: null },
    imageid: { String, default: '' },
    storyid: { String, default: '' },
    stories: { Array, default: null },
    refreshFeed: { Boolean, default: false },
    networkTimeout: { Boolean, default: false },
    scrollContainer: Object, // Pass the scrollable container
  },
  components: {
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonSpinner,
    SliderContainer,
    ShowMoreContainer,
    PostContainer,
    ShowMoreListContainer,
    IonSegment,
    IonSegmentButton,
    IonIcon,
    IonLabel,
    IonSkeletonText,
    IonGrid, 
    IonCol, 
    IonRow,
    WelcomeContainer,
    GroupsContainer,
    IonButton,
    ElectionFilter
  },
  setup() {
    return { pencil, grid, list }
  },
  mounted() {
    //console.log('mounted');
    if(this.scrollContainer != null){
      console.log('scrollContainer', this.scrollContainer);
      this.scrollContainerObject = this.scrollContainer;
    }else{
      console.log('no scrollContainer');
      this.scrollContainerObject = this.$refs.container;
    }
  },  
  data() {
    return {
      player: [],
      loading: false,
      pagingloading: null,
      profilepath: getEnv('AWS_URL') + getEnv('PHOTO_BUCKET') + '/profile/',
      popupEvent: null,
      imageSelected: 0,
      listType: 'list',
      report: false,
      electionRefresh: false,
      scrollContainerObject: null,
    }
  },
  methods: {
    async choosePostType() {
      if (this.reporter == 1) {
        const actionSheet = await actionSheetController.create({
          header: this.$t('modalhead.createpost'),
          buttons: [
            {
              text: this.$t('buttons.reportPost'),
              data: {
                action: 'post',
              },
            },
            {
              text: this.$t('buttons.reportElection'),
              data: {
                action: 'report',
              },
            },
            {
              text: this.$t('buttons.cancel'),
              role: 'cancel',
              data: {
                action: 'cancel',
              },
            },
          ],
        });

        await actionSheet.present();
        let dismissed = await actionSheet.onDidDismiss();
        if (dismissed != undefined) {
          if (dismissed.data.action != 'cancel') {
            if (dismissed.data.action == 'report') {
              this.report = true;
            }else{
              this.report = false;
            }
            await this.openModal();
          }
          console.log(dismissed.data, 'data');
        }
      } else {
        this.openModal();
      }

    },
    async openModal() {
      if (this.$store.state.auth.token != '') {
        const modal = await modalController
          .create({
            component: PostModal,
            cssClass: 'modal-custom-class',
            backdropDismiss: false, // Prevent dismissal by clicking outside
            componentProps: {
              title: this.$t('modaltitle.createpost'),
              share_link: '',
              report: this.report
            }
          })
        await modal.present();
        let dismissed = await modal.onDidDismiss();
        if (dismissed.role != 'canceled') {
          if(dismissed.role=='goLive'){
            console.log('go live');
            this.$router.push({ name: 'livebroadcast' });
          }else {
            this.doRefresh('mounted');
          }
          this.report = false;
        }
      } else {
        this.presentLoginAlertConfirm();
      }
    },
    async doRefresh(event) {
      //console.log('Begin async operation: ' + this.streamName);
      //this.$store.commit('helpers/setReloadStream', 'Y');
      //console.log(this.streamName);
      //this.$store.commit('pikstream/setLastId', 0);
      //this.$store.commit('pikstream/setTotalList', 7);
      if (this.streamName == "profile" || this.streamName == "ownerpreviewpremium") {
        this.$store.commit('pikstream/setProfileRequestNull', this.userid);
      } else if (this.streamName == "myprofile" || this.streamName == "premium" || this.streamName == "ownerpremium") {
        this.$store.commit('pikstream/setProfileRequestNull', this.userid);
        this.$store.commit('pikstream/setMyProfileRequest', null);
      } else if (this.streamName == "favorites") {
        this.$store.commit('pikstream/setFavoriteRequest', null);
      } else if (this.streamName == "home") {
        this.$store.commit('pikstream/setFollowRequest', null);
      } else if (this.streamName == "featured") {
        this.$store.commit('pikstream/setRecommendRequest', null);
      } else if (this.streamName == "elections") {
        this.$store.commit('pikstream/setElectionRequest', null);
      } else if (this.streamName == "grouppage") {
        this.$store.commit('pikstream/setGroupFeedRequestNull');
        this.$store.commit('pikstream/setGroupRequestNull', this.groupid);
      } else if (this.streamName == "groupfeed") {
        this.$store.commit('pikstream/setGroupFeedRequestNull');
      }

      /* if(this.$route.name=="myprofile"){
        this.$store.commit('pikstream/setCurrentPage', 0);
        this.$store.commit('pikstream/setTotalList', 7);
        this.$store.commit('pikstream/setMyProfileRequest', null);
      }else if(this.$route.name=="profile"){
        this.$store.commit('pikstream/setCurrentPage', 0);
        this.$store.commit('pikstream/setTotalList', 7);
        this.$store.commit('pikstream/setProfileRequest', [null, this.userid]);
      }else if(this.$route.name=="feed"){
        this.$store.commit('pikstream/setCurrentPage', 0);
        this.$store.commit('pikstream/setTotalList', 7);
        this.$store.commit('pikstream/setRequest', null);
      }else{
        this.$store.commit('pikstream/setCurrentPage', 0);
        this.$store.commit('pikstream/setTotalList', 7);
        this.$store.commit('pikstream/setProfileRequest', [null, 3]);
      }*/
      // this.current_page = 0;
      if (event == 'mounted') {
        this.loading = true;
        //await this.presentLoading();
        let response = await this.getStream();
        if (response) {
          //this.loadingIndicator.dismiss();
          this.loading = false;
        }
      }else {
        let response = await this.getStream();
        if (response == true) {
          event.target.complete();
          
        } 
        /*  setTimeout(() => {
          //console.log('Async operation has ended');
          event.target.complete();
        }, 4000);  */
      }
      this.$emit('update:refreshFeed', false);
      //console.log(event);
    },
    async presentLoading() {
      this.loadingIndicator = await loadingController
        .create({
          cssClass: 'loading-class',
          message: this.$t("loadmessage.loading"),
        });
      await this.loadingIndicator.present();
    },
    changeListType(ev) {
      let segmentValue = ev.target.value;
      this.listType = segmentValue;
      //console.log(segmentValue, 'event');
    },
    async loadMore(event) {
      if (this.stories == undefined || this.stories.length == 0) {
        //this.getStream();
        event.target.complete();
      } else {
        //console.log(this.loading, 'page continue');
        if (this.loading == false) {
          let last_story = this.stories.length - 1;
          if (last_story < 0) {
            return;
          }
          var updateLastId = 0;
          for (let i = 0; i < this.stories.length; i++) {
            if (this.stories[i].isAd == '' && this.stories[i].pinnedPost == null) {
              //console.log(last_story, 'not an ad');
              if (updateLastId == 0) {
                updateLastId = this.stories[i].pik_id;
                //console.log(updateLastId, 'last id');
              } else if (updateLastId > this.stories[i].pik_id) {
                updateLastId = this.stories[i].pik_id;
                //console.log(updateLastId, 'last id');
              }
            }
          }
          //console.log(this.last_id, updateLastId);
          if(this.last_id == updateLastId){
            event.target.complete();
            //event.target.disabled = true;
          }else{
            let pagingDone = await this.pageStream(updateLastId);
            if (pagingDone) {
              event.target.complete();
            }
          }
        }
      }
    },
    async getStream() {
      /* if(this.$store.state.auth.token==''){
        console.log('not logged in');
        this.presentLoginAlertConfirm();
      }*/
      //this.loading = true;
      this.$store.dispatch("video/getVideoBanner", {
        current_page: 0,
        total_list: 10,
      });
      console.log('getStream');
      let response = await this.$store.dispatch("pikstream/getStream", {
        streamName: this.streamName,
        filter: this.filter,
        imageid: this.imageid,
        storyid: this.storyid,
        total_list: this.total_list,
        last_id: this.last_id,
        userid: this.userid,
        groupid: this.groupid
      });
      if(response!=undefined){
        if(response.error != undefined){
          console.log('there was an error', response.error);
          this.$emit('update:networkTimeout', true);
          return false;
        }else{
          this.loading = false;
          if (this.$store.state.auth.token != '') {
            this.$store.dispatch("helpers/getNotifyBadges");
          }
          return response;
        }
      }
    },
    async pageStream(last_id) {
      // console.log('pageStream');
      var urlAddon = '';
      if (this.streamName == "profile" || this.streamName == "myprofile") {
        urlAddon = urlAddon.concat('&streamtype=profile');
      } else if (this.streamName == "premium") {
        urlAddon = urlAddon.concat('&streamtype=premium');
      } else if (this.streamName == "favorites") {
        urlAddon = urlAddon.concat('&streamtype=favorites');
      } else if (this.streamName == "ownerpremium") {
        urlAddon = urlAddon.concat('&streamtype=ownerpremium');
      } else if (this.streamName == "ownerpreviewpremium") {
        urlAddon = urlAddon.concat('&streamtype=ownerpreviewpremium');
      } else if (this.streamName == "story") {
        urlAddon = urlAddon.concat('&streamtype=story');
      } else if (this.streamName == "featured") {
        urlAddon = urlAddon.concat('&streamtype=featured');
      } else if (this.streamName == "elections") {
        urlAddon = urlAddon.concat('&streamtype=elections');
        if(this.electionStateName!=''){
          urlAddon = urlAddon.concat('&statename=' + encodeURIComponent(this.electionStateName));
        }
        if(this.electionCountyName!=''){
          urlAddon = urlAddon.concat('&countyname=' + encodeURIComponent(this.electionCountyName));
        }
        if(this.electionHashtag!=''){
          urlAddon = urlAddon.concat('&hashtag=' + encodeURIComponent(this.electionHashtag));
        }
      } else if (this.streamName == "grouppage") {
        urlAddon = urlAddon.concat('&streamtype=grouppage');
      } else if (this.streamName == "groupfeed") {
        urlAddon = urlAddon.concat('&streamtype=groupfeed');
      }

      /* if(this.filter!=null){
        urlAddon = urlAddon.concat('&filterProfile=' + this.filter);
      } */
      //console.log(this.last_id, 'image id to page from');
      if (this.imageid != null && this.imageid != '') {
        urlAddon = urlAddon.concat('&pikid=' + this.imageid);
      }
      if (this.userid != undefined && this.userid != '' && this.userid != this.myProfileId) {
        urlAddon = urlAddon.concat('&streamuserid=' + this.userid);
      }
      if (this.storyid != null && this.storyid != '') {
        urlAddon = urlAddon.concat('&id=' + this.storyid);
      }
      if (this.groupid != null && this.groupid != '') {
        urlAddon = urlAddon.concat('&group_id=' + this.groupid);
      }
      //var streamType = this.$route.name;
      //if(this.$route.name=='userprofile') streamType = 'profile';
      //console.log("PAGING: pikstream/grabv3?totalList=" + this.total_list + "&lastId=" + this.last_id + urlAddon);
      let response = await this.$store.dispatch("pikstream/pageData", {
        //url: "pikstream/grabv3?totalList=" + this.total_list + "&lastId=" + this.last_id + urlAddon,
        streamType: this.streamName,
        userId: this.userid,
        groupId: this.groupid,
        last_id: last_id,
        total_list: this.total_list,
        url_addon: urlAddon
      });
      this.loading = true;

      if (response) {
        this.loading = false;
        return true;
      }
    },
    async tryAgain(){
      this.$emit('update:networkTimeout', false);
      await this.getStream();
    },
    goToProfile() {
      this.$router.push({ name: 'profile', params: { id: this.myProfileId } });
    },
    async presentLoginAlertConfirm() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: this.$t('alerthead.login'),
          message: this.$t('alertmessage.login', { app: getEnv("APP_NAME") }),
          buttons: [
            {
              text: this.$t('buttons.cancel'),
              role: 'cancel',
              cssClass: 'secondary',
            },
            {
              text: this.$t('buttons.loginsignup'),
              handler: () => {
                this.$router.push("/login");
              },
            },

          ],
        });
      return alert.present();
    },
    async setRefocus() {
      if (this.imageSelected != 0) {
        var element = this.$refs['container'];
        await element.scrollIntoView({ behavior: "smooth" });
      }
      this.refocus = 0;
    },
    async setRefresh() {
      //console.log('check refresh');
      if (this.refreshFeed) {
        this.doRefresh('mounted');
      }
      if (this.electionRefresh) {
        this.doRefresh('mounted');
        this.electionRefresh = false;
      }
      //this.refresh = false;
    },
    dashMarginOverride() {
      let margin = '';
      if (this.$store.state.auth.token == '') {
        margin = 'margin-right:auto; margin-left:auto;';
      }
      return margin;
    },
    showNoPostDetail(){
      let detail = '';
      if(this.streamName=='profile' || this.streamName=='myprofile'){
        if(this.myProfileId==this.$route.params.id){
          detail = 'Once you post or re-post something, you will see it here.';
        }else{
          detail = 'Once this user posts, you will see it here.';
        }
      }else if(this.streamName=='favorites'){
        detail = 'When you save a post, you will see them here.<br /><a href="/home">Click here</a> to go to your home feed and save posts.';
      }else if(this.streamName=='grouppage'){
        detail = 'Once members post to this group, you will see it here.';
      }
      return detail;
    },
    containerClass(){
      let cssClass = 'dashboard-parent ion-content-scroll-host';
      if(this.streamName=='profile' || this.streamName=='myprofile' || this.streamName=='favorites' || this.streamName=='grouppage'){
        cssClass = 'parent';
      }
      return cssClass;

    }
  },
  watch: {
    imageSelected() {
      this.setRefocus();
    },
    refreshFeed() {
      this.setRefresh();
    },
    electionRefresh(){
      this.setRefresh();
    }
  },
  computed: {
    myProfileId() {
      return this.$store.state.profile.id;
    },
    myProfilePic() {
      return this.$store.state.profile.pic;
    },
    reporter() {
      return this.$store.state.profile.reporter;
    },
    electionStateName(){
      return this.$store.state.pikstream.electionStateName;
    },
    electionCountyName(){
      return this.$store.state.pikstream.electionCountyName;
    },
    electionHashtag(){
      return this.$store.state.pikstream.electionHashtag;
    },
    total_list() {
      let total = 0;
      if (this.streamName == "profile" || this.streamName == "ownerpreviewpremium") {
        total = this.$store.state.pikstream.totalList.profile[this.userid];
        } else if (this.streamName == "story"){
          total = this.$store.state.pikstream.totalList.story[this.imageid];
        } else if (this.streamName == "myprofile" || this.streamName == "ownerpremium" || this.streamName == "premium") {
          total = this.$store.state.pikstream.totalList.myprofile;
        } else if (this.streamName == "favorites") {
          total = this.$store.state.pikstream.totalList.favorite;
        } else if (this.streamName == "featured") {
          total = this.$store.state.pikstream.totalList.recommend;
        } else if (this.streamName == "elections") {
          total = this.$store.state.pikstream.totalList.election;
        } else if (this.streamName == "groupfeed") {
          total = this.$store.state.pikstream.totalList.groupfeed;
        } else if (this.streamName == "grouppage") {
          total = this.$store.state.pikstream.totalList.group[this.groupid];
        } else {
          total = this.$store.state.pikstream.totalList.follow;
        }

      return total; 
    },
    last_id() {
      let id = 0;
      if (this.streamName == "profile" || this.streamName == "ownerpreviewpremium") {
        id = this.$store.state.pikstream.lastId.profile[this.userid];
      } else if (this.streamName == "story") {
        id = this.$store.state.pikstream.lastId.story[this.imageid];
      } else if (this.streamName == "myprofile" || this.streamName == "ownerpremium" || this.streamName == "premium") {
        id = this.$store.state.pikstream.lastId.myprofile;
      } else if (this.streamName == "favorites") {
        id = this.$store.state.pikstream.lastId.favorite;
      } else if (this.streamName == "featured") {
        id = this.$store.state.pikstream.lastId.recommend;
      } else if (this.streamName == "elections") {
        id = this.$store.state.pikstream.lastId.elections;
      } else if (this.streamName == "groupfeed") {
        id = this.$store.state.pikstream.lastId.groupfeed;
      } else if (this.streamName == "grouppage") {
        id = this.$store.state.pikstream.lastId.group[this.groupid];
      } else {
        id = this.$store.state.pikstream.lastId.follow;
      }
      return id;
      //return this.$store.state.pikstream.lastId.follow;
    }
  }
});

</script>

<style>
.post-button {
  display: block;
  width: 100%;
  height: 44px;
  font-size: 18px;
  padding-left: 5px;
  padding-top: 10px;
  color: rgb(150, 150, 150);
  cursor: pointer;
}


.ion-content-scroll-host::before,
.ion-content-scroll-host::after {
  position: absolute;
  
  width: 1px;
  height: 1px;
  
  content: "";
}

.ion-content-scroll-host::before {
  bottom: -1px;
}

.ion-content-scroll-host::after {
  top: -1px;
}
</style>
